import {
  Grid,
  Card,
  Typography,
  Divider,
  Avatar,
  Stack,
  Box,
} from '@mui/material';
import { IForms106, getForm106File } from 'API/Paychecks/paychecks';
import { Download2, PurpleCircleBG } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { downloadFile } from 'Utils';
interface ICardForms106 {
  cardData: IForms106;
  isActive?: boolean;
}
export const CardForms106 = ({ cardData, isActive }: ICardForms106) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Paychecks);
  const isDesktop = useIsDesktop();
  const { isLoading, setIsLoading, loader } = useLoader(
    undefined,
    { height: 25, width: 'fit-content', ml: '25px' },
    isDesktop ? 30 : 20,
    false
  );

  const watchPdf = async () => {
    setIsLoading(true);

    const file = (await getForm106File(cardData.id))?.file;
    if (file) downloadFile(file, 'pdf', dictionary.tofes106FileName);

    setIsLoading(false);
  };

  return (
    <Card
      sx={{
        background: '#FFFFFF',
        display: 'flex',
        border: isActive ? '1px solid' : undefined,
        borderColor: 'purple2.shade_300',
        boxShadow: '0px 4px 20px rgba(45, 112, 217, 0.12)',
        borderRadius: '16px',
        minHeight: isDesktop ? '118px' : '96px',
        padding: isDesktop ? '24px 32px' : '16px 24px',
      }}
    >
      <Grid
        item
        xs={isDesktop ? 2 : 3}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Grid container direction='column' alignItems={'center'}>
          <Typography variant='body6' component='h3'>
            {dictionary.yearHe}
          </Typography>
          <Box
            sx={{
              background: `url(${PurpleCircleBG}) no-repeat left bottom`,
            }}
          >
            <Typography
              variant='h1'
              component={'h3'}
              sx={{ fontSize: { sm: '38px' } }}
            >
              {cardData.year}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={1}>
        <Divider
          orientation='vertical'
          aria-hidden={'true'}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            borderColor: 'primary.shade_100',
          }}
        />
      </Grid>
      <Grid
        item
        xs={isDesktop ? 9 : 8}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Grid container direction='column' pl={3} justifyContent={'center'}>
          {cardData.id && (
            <Stack
              flexDirection={'row'}
              alignItems={'center'}
              sx={{
                width: 'fit-content',
                cursor: 'pointer',
                ':hover': {
                  textDecoration: 'underline',
                },
              }}
              component={'a'}
              tabIndex={0}
              onClick={() => watchPdf()}
              onKeyUp={(e: React.KeyboardEvent) => {
                e.key === 'Enter' && watchPdf();
              }}
              aria-label={`${dictionary.tofes106FileName} ${dictionary.yearHe} ${cardData.year}`}
            >
              {isLoading ? (
                loader
              ) : (
                <>
                  <Avatar
                    src={Download2}
                    alt={''}
                    sx={{
                      width: '14px',
                      height: '17px',
                      mr: 1,
                    }}
                  />
                  <Typography variant='body5' color='primary.main'>
                    {dictionary.downloadForm}
                  </Typography>
                </>
              )}
            </Stack>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};
